import { createAction } from "redux-actions";

import { createAsyncAction } from "../helpers";

export const getFiltersDatesListAsyncAction = createAsyncAction(
	"GET_LEADERBOARD_DATE_FILTERS_LIST_REQUEST",
	"GET_LEADERBOARD_DATE_FILTERS_LIST_SUCCESS",
	"GET_LEADERBOARD_DATE_FILTERS_LIST_FAILURE",
	"GET_LEADERBOARD_DATE_FILTERS_LIST_CANCEL"
);

export const getFiltersDateAsyncAction = createAsyncAction(
	"GET_LEADERBOARD_DATE_FILTER_REQUEST",
	"GET_LEADERBOARD_DATE_FILTER_SUCCESS",
	"GET_LEADERBOARD_DATE_FILTER_FAILURE",
	"GET_LEADERBOARD_DATE_FILTER_CANCEL"
);

export const postFiltersDateAsyncAction = createAsyncAction(
	"POST_LEADERBOARD_DATE_FILTER_REQUEST",
	"POST_LEADERBOARD_DATE_FILTER_SUCCESS",
	"POST_LEADERBOARD_DATE_FILTER_FAILURE",
	"POST_LEADERBOARD_DATE_FILTER_CANCEL"
);

export const updateFiltersDateAsyncAction = createAsyncAction(
	"PUT_LEADERBOARD_DATE_FILTER_REQUEST",
	"PUT_LEADERBOARD_DATE_FILTER_SUCCESS",
	"PUT_LEADERBOARD_DATE_FILTER_FAILURE",
	"PUT_LEADERBOARD_DATE_FILTER_CANCEL"
);

export const deleteFiltersDateAsyncAction = createAsyncAction(
	"DELETE_LEADERBOARD_DATE_FILTER_REQUEST",
	"DELETE_LEADERBOARD_DATE_FILTER_SUCCESS",
	"DELETE_LEADERBOARD_DATE_FILTER_FAILURE",
	"DELETE_LEADERBOARD_DATE_FILTER_CANCEL"
);

export const resetAction = createAction("LEADERBOARD_RESET_ACTIONS");
